import { useSelector } from 'react-redux';
import styles from './styles.module.scss';
import { RootState } from '@/lib/store';
import { useMemo } from 'react';
import SearchHistoryChip from './Chip';

export default function SearchHistoryList() {
  const searchHistory: string[] = useSelector(
    (state: RootState) => state.casino.searchHistory,
  );
  const Chips = useMemo(
    () =>
      searchHistory.map((text, index) => (
        <SearchHistoryChip
          key={`search-history-item-${index}`}
          index={index}
          text={text}
        />
      )),
    [searchHistory],
  );

  return <div className={styles.container}>{Chips}</div>;
}
